module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=modal-body> <div ng-bind-html=\"textKey | translate\"></div> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-help-text/cn-help-text.modal.tpl.html
 ** module id = 131
 ** module chunks = 0
 **/